// extracted by mini-css-extract-plugin
export const section = "embeddedVideo-module--section--2xdZ2";
export const container = "embeddedVideo-module--container--1AqTy";
export const pageContent = "embeddedVideo-module--pageContent--1yeMZ";
export const footer = "embeddedVideo-module--footer--3aoIX";
export const modal = "embeddedVideo-module--modal--2OeON";
export const sContainer = "embeddedVideo-module--sContainer--22hHc";
export const wrap = "embeddedVideo-module--wrap--1tCXs";